module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/logo1m.15061a2e.png";